import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice de devises - Convertir les nombres en textes arabes";
const DESCRIPTION =
  "Calculatrice de devises - Convertir les nombres en textes arabes. Outil en ligne en francais pour obtenir un resultat rapide, clair et utile dans vos besoins du quotidien.";
const KEYWORDS =
  "currency spreading, calculatrice en ligne, outil pratique, utilitaire quotidien, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/currency-spreader/";

function numberToFrenchText(num) {
  const ones = [
    "",
    "un",
    "deux",
    "trois",
    "quatre",
    "cinq",
    "six",
    "sept",
    "huit",
    "neuf",
  ];
  const tens = [
    "",
    "dix",
    "vingt",
    "trente",
    "quarante",
    "cinquante",
    "soixante",
    "soixante-dix",
    "quatre-vingts",
    "quatre-vingt-dix",
  ];
  const hundreds = [
    "",
    "cent",
    "deux cents",
    "trois cents",
    "quatre cents",
    "cinq cents",
    "six cents",
    "sept cents",
    "huit cents",
    "neuf cents",
  ];
  
  let str = "";
  if (num >= 100) {
    str += hundreds[Math.floor(num / 100)] + " ";
    num %= 100;
  }
  if (num >= 20) {
    str += tens[Math.floor(num / 10)] + " ";
    num %= 10;
  }
  if (num >= 10 && num < 20) {
    str += tens[Math.floor(num / 10)] + " ";
    num = 0;
  }
  if (num > 0) {
    if (str !== "") {
      str += "et ";
    }
    str += ones[num] + " ";
  }
  return str.trim();
}

function CurrencyConverter() {
  const [amount, setAmount] = useState("");
  const [currency, setCurrency] = useState("EUR");
  const [textAmount, setTextAmount] = useState("");

  const handleConvert = () => {
    if (!amount || isNaN(amount)) {
      setTextAmount("");
      return;
    }
    const num = parseInt(amount);
    const text = numberToFrenchText(num);
    setTextAmount(text);
  };

  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Convertissez facilement les montants en mots français. Entrez un montant et la calculatrice affichera
                  comment l'écrire en toutes lettres.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group">
                    <label>Montant:</label>
                    <input
                      type="number"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      className="form-control"
                      placeholder="Entrez un montant"
                    />
                  </div>
                  <div className="form-group">
                    <label>Devise:</label>
                    <select value={currency} onChange={(e) => setCurrency(e.target.value)} className="form-control">
                      <option value="EUR">Euro (€)</option>
                      <option value="USD">Dollar ($)</option>
                      <option value="GBP">Livre (£)</option>
                      <option value="CHF">Franc (CHF)</option>
                    </select>
                  </div>
                  <button onClick={handleConvert} className="btn btn-success w-100">
                    Convertir
                  </button>
                </div>
              </div>
              <div className="col-sm-12 col-md-6">
                {textAmount && (
                  <div className="bg-light p-3 rounded">
                    <h3>En mots:</h3>
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>{textAmount} {currency}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <SecondAds />
        </div>
      </div>
    </div>
  );
}

export default CurrencyConverter;